import { addEncryptUrl } from "@/utils/requestCrypto";
import { decrypt } from "@/utils/crypt";
import { sleep } from "@/utils/index";
import useDeviceEnv from "../useDeviceEnv/useDeviceEnv";
import { getStorage } from "@/utils/storage";
const { deviceInfo } = useDeviceEnv();

const isJson = (str) => {
  if (typeof str == "string") {
    try {
      const obj = JSON.parse(str);
      if (typeof obj == "object" && obj) {
        return true;
      } else {
        return false;
      }
    } catch {
      return false;
    }
  }
  return false;
};

// options: { url, data } 必传
// options: { isAgain, againPrams } 非必传
const useFetchChat = (options) => {
  const url = options.url;
  const data = options.data;
  let isAgain = options.isAgain || true;
  const abortController = new AbortController();
  const headerObj = {
    "Content-Type": "application/json",
    Authorization: getStorage("token"),
  };
  const fetchOptions = {
    method: "POST",
    timeout: 30000, // 设置超时时间为10秒
    headers: headerObj,
    body: JSON.stringify(data),
    signal: abortController.signal,
  };

  // opts: { accept, done, error } 必传
  const getFetchResult = (opts, control = {}) => {
    const returnStreamText =
      control?.returnStreamText === undefined
        ? true
        : control?.returnStreamText;

    return new Promise((resolve) => {
      const doneFetch = () => {
        opts.done();
        resolve();
      };
      const errFetch = (error) => {
        const code = error.code;
        if (isAgain && [410, 423].includes(code)) {
          isAgain = false;
          // 清空消息
          opts.accept({
            clearMsg: true,
          });
          fetchOptions.body = JSON.stringify({
            ...data,
            not_sensitive: true,
          });
          return getFetchResult(opts, control);
        } else if (isAgain) {
          isAgain = false;
          if (options.againPrams) {
            fetchOptions.body = JSON.stringify({
              ...data,
              ...options.againPrams,
            });
          } else {
            fetchOptions.body = JSON.stringify({
              ...data,
            });
          }
          return getFetchResult(opts, control);
        }
        opts.error(code, error);
        resolve();
      };
      let allText = "";
      // const collectObj = [];
      const throwText = async (obj) => {
        // collectObj.push(obj);
        // console.log("collectObj", obj);
        if (obj.status === 204) {
          return opts.reset();
        }
        // eslint-disable-next-line no-prototype-builtins
        if (obj.hasOwnProperty("message_type")) {
          // 角色对话
          return opts.accept(obj);
        }
        if (obj.message) {
          const contentObj = JSON.parse(JSON.stringify(obj));
          contentObj.message = "";
          opts.accept(contentObj);
          const substr = obj.message;
          allText += substr;
          const textList = allText.split("```");
          let isCode = false;
          if (textList.length % 2 === 0) {
            isCode = true;
          }
          if (returnStreamText && !isCode) {
            // console.log("substr", substr);
            const subStrLength = substr.length;
            for (let i = 0; i < substr.length; i++) {
              if (subStrLength === 1) {
                await sleep(28);
              } else if (subStrLength === 2) {
                await sleep(20);
              } else {
                await sleep(10);
              }
              opts.accept(substr[i]);
            }
          } else {
            opts.accept(substr);
          }
        } else {
          await opts.accept(obj);
        }
      };
      const {
        url: encryptUlr,
        data: encryptBody,
        header: encryptHeaders,
      } = addEncryptUrl({ url, data: fetchOptions.body, header: headerObj });
      fetchOptions.body = JSON.stringify(encryptBody);
      fetchOptions.headers = encryptHeaders;
      const keepalive = canKeepAlive(fetchOptions.body);
      fetchOptions.keepalive = keepalive;
      fetch(encryptUlr, fetchOptions)
        .then(async (res) => {
          if (res.status === 403) return errFetch({ code: 403 });
          if (res.status > 300) return errFetch({ code: 410 });
          const r = res.body;
          if (!r) return errFetch({ code: 420 });
          const d = new TextDecoder("utf8");
          const reader = r?.getReader();
          let longSubstr = "";
          // eslint-disable-next-line no-constant-condition
          while (true) {
            const { value, done } = await reader.read();
            const decodedString = d.decode(value);
            // console.log("decodedString", decodedString);
            if (done) {
              return doneFetch();
            }
            let arr = decodedString.split("\n");
            for (let i = 0; i < arr.length; i++) {
              if (arr[i] === "" || arr[i] === "data:[DONE]") {
                continue;
              }
              let substr = arr[i].slice(5);
              substr = decrypt(substr);
              if (longSubstr) {
                let finalSubstr = longSubstr + arr[i];
                let finalObj = decrypt(finalSubstr);
                if (typeof finalObj === "object") substr = finalObj;
              }
              if (typeof substr === "string") {
                if (isJson(substr)) {
                  substr = JSON.parse(substr);
                  await throwText(substr);
                } else {
                  // 如果无法解析，可以默认为是长对话，被截断了
                  if (arr[i].startsWith("data:")) {
                    longSubstr += arr[i].slice(5);
                  } else {
                    longSubstr += arr[i];
                  }
                }
              } else if (typeof substr === "object") {
                // 429 请求失败
                // 402 余额不足
                // 410 423 敏感词
                // 204 204 时候。说明前面内容出现敏感词，清空内容，后面重新回答提问
                // 600 角色对话的报错
                if ([429, 402, 410, 423, 416, 600].includes(substr.status)) {
                  return errFetch({ code: substr.status, data: substr });
                }
                await throwText(substr);
              }
            }
          }
        })
        .catch((err) => {
          console.log("err", err);
          errFetch({ code: 500, message: err.message });
        });
    });
  };

  return {
    abortController,
    getFetchResult,
  };
};

function getStringByteCount(str) {
  const encoder = new TextEncoder();
  const bytes = encoder.encode(str);
  return bytes.length;
}
function canKeepAlive(str) {
  const { deviceInfo } = useDeviceEnv();
  // 使用keepalive后，body限制64KB，暂时改成false
  let keepalive = false;
  if (getStringByteCount(str) < 64 * 1024) {
    keepalive = true;
  }
  if (deviceInfo.isDesktop) {
    keepalive = false;
  }
  return keepalive;
}

export default useFetchChat;

// const pic = {
//   id: "1852267839956717568",
//   message: "standing on the beach with the ocean in the background",
//   message_type: 1,
//   picture:
//     "https://cdn.midjourny.cn/cosplay/images/2024/11/01/1852267831660384256.png?auth_key=1730451841-882c7f33ded9453ab8f7da2115c95a58-0-65e3ee70cbe0aeb55b9bbe56f320e40e",
//   tc: 1.97827886,
// };

//
// const text = {
//   id: "1852267841399558144",
//   message: "这是我之前拍的。",
//   message_type: 0,
// };
